<template>
  <div class="card" >
    <div class="header">
      <div class="title">{{ translate("device.simcard_status")}}</div>
    </div>
    <div class="content" v-on:wheel="wheel">
      <div style="text-align: center;  vertical-align: middle;">
        <span><span class="time_legend">NONE: </span> <span class="NONE block-legend" /></span>
        <span><span class="time_legend">NA: </span> <span class="NA block-legend" /></span>
        <span><span class="time_legend">2G: </span> <span class="_2G block-legend" /></span>
        <span><span class="time_legend">3G: </span> <span class="_3G block-legend" /></span>
        <span><span class="time_legend">4G: </span> <span class="_4G block-legend" /></span>
      </div>
      <div class="echarts_timeline">
        <div class="spinner_charts" v-if="load">
          <scale-loader style="position: relative; padding-top: 10%" />
        </div>
        <IEcharts
          v-if='show_content'
          :option="option"
          @ready="onReady"
        />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'TimelineChart',
  props: ['main_data', 'dev_id', 'show_content', 'today'],

  data () {
    // const that = this
    return {
      ins: null,
      echarts: null,
      show: false,
      data2: [],
      show2: false,
      load: true
    }
  },
  computed: {
    info(){
      return this.main_data
    },
    option () {
      return {
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: this.translate('save'),
              type: 'png',
              pixelRatio: 5

            }
          }
        },
        tooltip: {
          formatter: (params) => {
            let date = new Date()
            if (params.value === undefined) {
              return ''
            }
            date.setTime(params.value[1])
            let date2 = new Date()
            date2.setTime(params.value[2])
            let options = {hour: '2-digit', minute: '2-digit', hour12: false}
            return params.marker + this.info.category[params.value[0]] + ': ' + params.data.mode + '  ' + params.data.rssi + 'dBm (' + date.toLocaleString(navigator.language, options) + '-' + date2.toLocaleString(navigator.language, options) + ')<br/>'
          }
        },
        dataZoom: [{
          type: 'slider',
          filterMode: 'weakFilter',
          showDataShadow: false,
          height: 20,
          realtime: false,
          borderColor: 'transparent',
          backgroundColor: '#e2e2e2',
          handleSize: 25,

          preventDefaultMouseMove: false,
          handleStyle: {
            shadowBlur: 6,
            shadowOffsetX: 1,
            shadowOffsetY: 2,
            shadowColor: '#aaa'
          }
        }],
        grid: {
          height: '55%',
          left: 90,
          right: 35
        },
        xAxis: {
          scale: true,
          type: 'time',
          axisLabel: {
            formatter: this.translate_of_time
          }
        },
        yAxis: {
          axisPointer: {
            show: true,
            type: 'shadow'
          },
          data: this.set_category()
        },
        series: [{
          animation: true,
          animationEasing: 'linear',
          animationEasingUpdate: 'linear',
          type: 'custom',
          renderItem: this.renderItem,
          itemStyle: {
            opacity: 0.8
          },
          encode: {
            x: [1, 2],
            y: 0
          },
          data: this.data2
        }]
      }
    }
  },

  watch: {
    info () {
      if (this.info.data && Object.keys(this.info.data).length !== 0) {
        this.load = false
        this.data2 = this.info.data
      } else {
        this.load=true
      }
    }
  },
  methods: {
    translate_of_time(unixTime){
      let options = {}
      if (this.today) {
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit'
        }
      }else{
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          day: '2-digit',
          month: '2-digit'
        }
      }
      return this.get_date(unixTime/1000, options)
    },
    wheel (event) {
      if (event.shiftKey) {

        let start = this.ins.getOption().dataZoom[0].start + event.zrDelta * 2
        let end = this.ins.getOption().dataZoom[0].end - event.zrDelta * 2
        if(start < 0 || end > 100 || start > end || end < start || (end - start <= 0) ) {
          return false
        }
        this.ins.dispatchAction({
          type: 'dataZoom',
          start: start,
          end: end,
        })
      }
    },
    set_category () {
      let cat = []
      let category = ''
      let size = 0

      for (let i in this.info.category) {
        category = this.info.category[i]
        if (category.length > 14) {
          category = category.substr(0, 10) + '...'
          size = 12
        } else {
          let max = 23
          size = max - category.length
        }
        cat.push({
          value: category,
          align: 'left',
          textStyle: {
            fontSize: size
          }
        })
      }
      return cat
    },
    onReady (instance, echarts) {
      const that = this
      that.ins = instance
      that.echarts = echarts
      this.load = true;
      this.data2 = this.info.data
      that.ins.on('finished',() => {
        setTimeout(() => this.load = false, 100)
      })
      // Функция давно не работает и решили её закоментировать, чтобы доработать
      // that.ins.on('click', function (params) {
      //   that.$http.getLogSlice(that.dev_id, { start: (params.value[1] / 1000).toFixed(), end: (params.value[2] / 1000).toFixed() }, (resp) => {
      //     let date = new Date()
      //     date.setTime(params.value[1])
      //     let date2 = new Date()
      //     date2.setTime(params.value[2])
      //     let options = {hour: '2-digit', minute: '2-digit', hour12: false}
      //     var t = that.$createElement(TimelineLog, { props: {
      //       time: date.toLocaleString(navigator.language, options) + '-' + date2.toLocaleString(navigator.language, options),
      //       log: resp.data,
      //       fid: that.dev_id
      //     },
      //     on: {close: () => { that.$modal.hide('dynamic-modal') }} })
      //     let temp = {
      //       render () { return t }
      //     }
      //     that.$modal.show(temp, {}, {height: 'auto', name: 'dynamic-modal'})
      //   })
      // })
      const updatePosition = function () {
        if (that.ins.resize !== undefined || that.ins.resize !== null) {
          that.ins.resize()
        }
      }
      window.addEventListener('resize', updatePosition)
      updatePosition()
    },

    renderItem (params, api) {
      var categoryIndex = api.value(0)
      var start = api.coord([api.value(1), categoryIndex])
      var end = api.coord([api.value(2), categoryIndex])
      var height = api.size([0, 1])[1] * 0.6

      return {
        type: 'rect',
        shape: this.echarts.graphic.clipRectByRect({
          x: start[0],
          y: start[1] - height / 2,
          width: (end[0] - start[0]),
          height: height
        }, {
          x: params.coordSys.x,
          y: params.coordSys.y,
          width: params.coordSys.width,
          height: params.coordSys.height
        }),
        style: api.style()
      }
    }
  }
}
</script>
<style>
  .echarts_timeline {
    width: 100%;
    height: 290px;
    margin: 0 auto;
    margin-top: -65px;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  .block-legend {
    width: 40px;
    height: 20px;
    padding: 0;
    border-radius: 5px;
    display: inline-block;
  }

  .time_legend {
    vertical-align: super;
    margin-left: 5px;
  }

  .NA {
    background-color:#FF0000;
  }
  ._2G {
      background-color:#FFA500 ;
    }
  ._3G {
      background-color:#FFFF00 ;
    }
  ._4G {
      background-color:#008000 ;
    }
  .NONE {
    background-color:#858585 ;
  }



</style>
